import { useEffect, useState, useMemo, useCallback } from "react";

import { wrapTo } from "../utils";

const slideClassNames = ['prev-hidden','prev-hidden','prev-hidden','prev-hidden', 'prev-prev', 'prev', 'selected', 'next', 'next-next', 'next-hidden','next-hidden','next-hidden'];


const CustomPicker = (props) => {
	const {selections, className: rootClassName, onUpdate} = props;
    const [slideIdx, updateSlide] = useState(0)

	const goToSlide = useCallback((targetIdx) => {
        updateSlide(targetIdx)
    }, []);

    const prevItem = useCallback(() => {
		updateSlide(index => wrapTo(index + 1, 0, slideClassNames.length));
    }, []);

	const nextItem = useCallback(() => {
		updateSlide(index => wrapTo(index - 1, 0, slideClassNames.length));
    }, []);

	const {slides, selectedItem} = useMemo(() => {
		const selectedIndex = slideClassNames.indexOf('selected');
		let selectedItem = null;
		const slides = [];
		for(let i = 0; i < slideClassNames.length; i++) {
			const classNameIndex = (i + slideIdx) % slideClassNames.length;
			const className = slideClassNames[classNameIndex];
			const isSelected = classNameIndex === selectedIndex;
			const item = selections[i % selections.length];
			const index = wrapTo(selectedIndex - i, 0, slideClassNames.length);

			slides.push({
				className,
				isSelected,
				item,
				index,
			});
			if(isSelected){
				selectedItem = item;
			}
		}
		

		return {slides, selectedItem};
	}, [selections, slideIdx]);
    
	const itemElements = useMemo(() => {
		return slides.map((slide, i) => {
			const slideClassName = slide.className;
			const itemClassName = slide.item.name;
			return(
				<button key={i} 
					onClick={()=>{goToSlide(slide.index)}}
					className={['single-item',slideClassName,itemClassName,rootClassName].join(' ')}>{itemClassName}</button>
			)
		});
	}, [goToSlide, rootClassName, slides])

    useEffect(()=>{
		onUpdate(selectedItem);
    },[onUpdate, selectedItem, selectedItem.id])


    return(
        <div className="custompicker">
            <button onClick={prevItem} className="custompicker-arrow left"><i className="fa fa-angle-left" /></button>
            <div className="custompicker-content">
                {itemElements}
            </div>
            <button onClick={nextItem} className="custompicker-arrow right"><i className="fa fa-angle-right" /></button>
        </div>
    )
}
export default CustomPicker;